<mat-toolbar class="subtitulo">Ação Executada</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <form #formConsultar="ngForm">
        <div fxLayout="column">
            <div fxLayout="row">
                <div ngModelGroup="comboAtividade" fxFlex="100">
                    <combo-atividade [desabilitado]="acaoExecutada.id || campoDesabilitado()"
                                     [obrigatorio]="true"
                                     [selecionado]="atividade"
                                     (valorChange)="onValorChangeAtividade($event)">
                    </combo-atividade>
                </div>
            </div>
            <div fxLayout="row" *ngIf="atividade?.id">
                <div ngModelGroup="comboAcaoAtividade" fxFlex="100">
                    <combo-acao-atividade [desabilitado]="acaoExecutada.id || !atividade?.id || campoDesabilitado()"
                                          [obrigatorio]="true"
                                          [selecionado]="acao"
                                          (valorChange)="onValorChangeAcao($event)"
                                          [idAtividade]="atividade?.id">
                    </combo-acao-atividade>
                </div>
            </div>
            <div *ngIf="atividade?.id">
                <div fxLayout="row" fxLayoutGap="20px">
                    <mat-form-field fxFlex="50" fxFlexOffset="20px">
                        <input #descricao matInput maxlength="200" name="descricao" placeholder="Descrição"
                               [(ngModel)]="acaoExecutada.descricao" required [disabled]="campoDesabilitado()">
                        <mat-hint align="end">{{ descricao.value.length }} / 200</mat-hint>
                    </mat-form-field>

                    <mat-form-field fxFlex="15">
                        <input matInput name="dataInicioAcao" [matDatepicker]="dataInicioAcao" placeholder="Data Início:"
                               [(ngModel)]="acaoExecutada.dataInicio" (input)="onMascaraDataInput($event)"
                               [disabled]="campoDesabilitado()">
                        <mat-datepicker-toggle matSuffix [for]="dataInicioAcao"></mat-datepicker-toggle>
                        <mat-datepicker #dataInicioAcao></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field fxFlex="10">
                        <input matInput #horaInicio="ngModel" mat-hide-icons="calendar" type="time" name="horaInicio"
                               placeholder="Hora Início:" [(ngModel)]="acaoExecutada.horaInicio" [disabled]="campoDesabilitado()">
                    </mat-form-field>

                    <mat-form-field fxFlex="15">
                        <input matInput name="dataFimAcao" [matDatepicker]="dataFimAcao" placeholder="Data Fim:"
                               [(ngModel)]="acaoExecutada.dataFim" (input)="onMascaraDataInput($event)"
                               [disabled]="campoDesabilitado()">
                        <mat-datepicker-toggle matSuffix [for]="dataFimAcao"></mat-datepicker-toggle>
                        <mat-datepicker #dataFimAcao></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field fxFlex="10">
                        <input matInput mat-hide-icons="calendar" type="time" name="horaFimAcao"
                               placeholder="Hora Fim:" [(ngModel)]="acaoExecutada.horaFim" [disabled]="campoDesabilitado()">
                    </mat-form-field>
                </div>

                <div fxLayout="row" fxLayoutGap="20px">
                    <mat-form-field fxFlex="33" fxFlexOffset="20px">
                        <input #descricaoOcorrenciaAcao matInput maxlength="200" name="descricaoOcorrenciaAcao"
                               placeholder="Ocorrência" [(ngModel)]="acaoExecutada.descricaoOcorrencia"
                               [disabled]="campoDesabilitado()">
                        <mat-hint align="end">{{ descricaoOcorrenciaAcao.value.length }} / 200</mat-hint>
                    </mat-form-field>

                    <mat-form-field fxFlex="33">
                        <input #descricaoMetodologiaAcao matInput maxlength="200" name="descricaoMetodologiaAcao"
                               placeholder="Metodologia" [(ngModel)]="acaoExecutada.descricaoMetodologia"
                               [disabled]="campoDesabilitado()">
                        <mat-hint align="end">{{ descricaoMetodologiaAcao.value.length }} / 200</mat-hint>
                    </mat-form-field>

                    <mat-form-field fxFlex="33">
                        <input #descricaoAvaliacaoAcao matInput maxlength="200" name="descricaoAvaliacaoAcao"
                               placeholder="Avaliação" [(ngModel)]="acaoExecutada.descricaoAvaliacao"
                               [disabled]="campoDesabilitado()">
                        <mat-hint align="end">{{ descricaoAvaliacaoAcao.value.length }} / 200</mat-hint>
                    </mat-form-field>
                </div>

                <div fxLayout="row">
                    <mat-form-field fxFlex="20" fxFlexOffset="20px">
                        <input matInput #qtdParticipantes="ngModel"
                               name="qtdParticipantes"
                               placeholder="Quantidade de Participantes:"
                               [(ngModel)]="acaoExecutada.qtdParticipantes"
                               maxlength="6"
                               pattern="[0-9]+$"
                               [disabled]="campoDesabilitado()">
                    </mat-form-field>

                    <div ngModelGroup="comboFuncionario" fxFlex="80">
                        <combo-funcionario [showDisplayId]="false"
                                           [obrigatorio]="false"
                                           [selecionado]="acaoExecutada.funcionarioResponsavel"
                                           (valorChange)="onValorChangeFuncionario($event)"
                                           [label]="'Funcionário Responsável'"
                                           [desabilitado]="campoDesabilitado()">
                        </combo-funcionario>
                    </div>
                </div>
                <mat-tab-group #tabGroup>
                    <mat-tab label="METAS DA AÇÃO EXECUTADA">
                        <div ngModelGroup="grupoAcoesMetas" fxLayout="column" fxFlex="100%" style="margin: 2px 0;">
                            <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px">
                                <div *ngFor="let meta of acaoExecutada.metas; let index = index">
                                    <formulario-metas [meta]="meta"
                                                      [index]="index"
                                                      [metas]="acaoExecutada.metas"
                                                      [perfilAcesso]="perfilAcesso"
                                                      [idAtividade]="atividade.id"
                                                      [desabilitarCampos]="campoDesabilitado()">
                                    </formulario-metas>
                                </div>
                                <div *ngIf="!campoDesabilitado()" fxLayoutAlign="start center" fxLayoutGap="16px"
                                     style="padding-top: 10px; padding-left: 20px;">
                                    <div>
                                        <button matTooltip="Nova Meta" mat-mini-fab color="primary" (click)="addMeta()"
                                                style="width: 140px;border-radius: 5px;">
                                            <mat-icon>add</mat-icon>
                                            Meta
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="COLABORADORES">
                        <div ngModelGroup="grupoColaboradorAcoesExecutadas" fxLayout="column" fxFlex="100%"
                             style="margin: 2px 0;">
                            <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px">
                                <div *ngFor="let colaboradorAcao of acaoExecutada.colaboradores; let index = index">
                                    <formulario-colaborador [colaboradorAcao]="colaboradorAcao"
                                                            [index]="index"
                                                            [colaboradoresAcao]="acaoExecutada.colaboradores"
                                                            [perfilAcesso]="perfilAcesso"
                                                            [desabilitarCampos]="campoDesabilitado()">
                                    </formulario-colaborador>
                                </div>
                                <div *ngIf="!campoDesabilitado()" fxLayoutAlign="start center" fxLayoutGap="16px"
                                     style="padding-top: 10px; padding-left: 20px;">
                                    <div>
                                        <button matTooltip="Novo Colaborador" mat-mini-fab color="primary"
                                                (click)="addColaboradorAcao()"
                                                style="width: 140px;border-radius: 5px;">
                                            <mat-icon>add</mat-icon>
                                            Colaborador
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="PARTICIPANTES">
                        <div ngModelGroup="grupoFrequenciaAcoesExecutadas" fxLayout="column" fxFlex="100%" style="margin: 2px 0;">
                            <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px">
                                <div *ngFor="let frequenciaAcao of acaoExecutada.frequencias; let index = index">
                                    <formulario-frequencia [frequenciaAcao]="frequenciaAcao"
                                                           [index]="index"
                                                           [frequenciasAcao]="acaoExecutada.frequencias"
                                                           [perfilAcesso]="perfilAcesso"
                                                           [desabilitarCampos]="campoDesabilitado()">
                                    </formulario-frequencia>
                                </div>
                                <div *ngIf="!campoDesabilitado()" fxLayoutAlign="start center" fxLayoutGap="16px"
                                     style="padding-top: 10px; padding-left: 20px;">
                                    <div>
                                        <button matTooltip="Nova Frequencia" mat-mini-fab color="primary"
                                                (click)="addFrequenciaAcao()"
                                                style="width: 140px;border-radius: 5px;">
                                            <mat-icon>add</mat-icon>
                                            Participante
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>

        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
            <button *ngIf="!isAtualizar && mostrarBotaoCadastrar"
                    mat-raised-button name="botaoConfirmar" fxFlex="20%" color="primary" (click)="cadastrar()">
                Cadastrar
            </button>
            <button *ngIf="isAtualizar && mostrarBotaoAtualizar"
                    mat-raised-button name="botaoConfirmar" fxFlex="20%" color="primary" (click)="atualizar()">
                Atualizar
            </button>
            <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                Limpar
            </button>
            <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                Cancelar
            </button>
        </div>
    </form>
</div>